import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import { useAuth } from "@/hooks/useAuth";
import { COOKIE_KEYS } from "@/shared/constants/cookies.const";
import { DiscoverBodySkeleton } from "@/routes/RouteFallback";

/**
 * Guest-only routes (public Discover, etc.).
 *
 * Critical 3G path: do NOT block pure guests on silent `/auth/refresh`.
 * That refresh returns 401 with no session and used to delay Discover (and its
 * API shimmer) until bootstrap finished — blank chrome for many seconds.
 * Only wait when an access cookie exists (session may still restore).
 */
export function GuestRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const hasAccessCookie = Boolean(Cookies.get(COOKIE_KEYS.token));

  if (isAuthenticated) {
    return <Navigate to="/profile" replace />;
  }

  if (isLoading && hasAccessCookie) {
    return <DiscoverBodySkeleton withNavOffset={false} />;
  }

  return <Outlet />;
}
